import { Modal } from "@mantine/core";
import { useViewportSize } from "@mantine/hooks";
import { ReactComponent as CloseIcon } from "@assets/icons/close_bold.svg";
import { ReactComponent as DollarIcon } from "@assets/icons/dollar.svg";
import { ReactComponent as StoreIcon } from "@assets/icons/building_store.svg";
import { ReactComponent as BankHouseIcon } from "@assets/icons/bank_house.svg";
import { ReactComponent as HashtagIcon } from "@assets/icons/hashtag.svg";
import { ReactComponent as CalendarIcon } from "@assets/icons/calendar.svg";
import React from "react";
import { useNavigate } from "react-router-dom";

type ModalHandyPAProps = {
  open: boolean;
  onClose(): void;
};

const ModalHandyPA: React.FC<ModalHandyPAProps> = ({ open, onClose }) => {
  const { width: sizeWidth } = useViewportSize();
  const navigate = useNavigate();

  const cards = [
    {
      label: "Contribution Amount",
      sublabel: "How much you want to contribute",
      icon: <DollarIcon className="w-6 h-6" />,
    },
    {
      label: "Business Details",
      sublabel: "Information about your company if director",
      icon: <StoreIcon className="w-6 h-6" />,
    },
    {
      label: "Payment Information",
      sublabel: "Information about your company if director",
      icon: <BankHouseIcon className="w-6 h-6" />,
    },
    {
      label: "Proof of PPSN",
      sublabel: "A document that proves your PPSN number",
      icon: <HashtagIcon className="w-6 h-6" />,
    },
    {
      label: "Proof of Date of Birth",
      sublabel: "A certificate that displays your birthday e.g identity card",
      icon: <CalendarIcon className="w-6 h-6" />,
    },
  ];

  return (
    <Modal
      size={sizeWidth > 1024 ? 410 : 343}
      centered
      withCloseButton={false}
      opened={open}
      onClose={() => {}}
      styles={{
        body: {
          padding: "0px",
        },
        content: {
          borderRadius: "16px",
        },
      }}
    >
      <div className="flex flex-col">
        <div className="flex items-center justify-between py-4 px-6">
          <span className="text-pn-headline-emphasis">Have Handy</span>
          <button onClick={onClose} className="btn-secondary-icon-xs w-fit">
            <CloseIcon className="w-4 h-4" />
          </button>
        </div>
        <div className="flex flex-col gap-y-4">
          {cards.map((item, index) => (
            <div key={index} className="p-4 flex items-center gap-x-4">
              <div className="w-10 h-10 rounded-full bg-pn_gray-200 flex items-center justify-center">
                {item.icon}
              </div>
              <div className="flex flex-col gap-y-1 flex-1">
                <span className="text-pn-body-large-emphasis">
                  {item.label}
                </span>
                <span className="text-pn-body-small-regular">
                  {item.sublabel}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="px-6 py-4 w-full">
          <button
            onClick={() => navigate("activity-details/add-details")}
            className="btn-primary-lg w-full md:btn-primary-sm2 text-center"
          >
            Next
          </button>
        </div>
      </div>
    </Modal>
  );
};
export default ModalHandyPA;
